import { render, staticRenderFns } from "./Bionet.vue?vue&type=template&id=a81a0c54&"
import script from "./Bionet.vue?vue&type=script&lang=js&"
export * from "./Bionet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports